import * as React from "react";
import { StyleProp, ViewStyle } from "react-native";
import Svg, { Path } from "react-native-svg";
import { getPrimaryColor } from "../../../src/utils/ColorsFunctions";
import { useAppSelector } from "../../../src/hooks/reduxHooks";

const QuestionMark = (props: { style?: StyleProp<ViewStyle> }) => {
	const user = useAppSelector((s) => s.auth.subUser!);

  return (
    <Svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill={getPrimaryColor(user)}
      {...props}
    >
      <Path
        d="M7.90893 4.13036L7.90892 4.12943C7.90302 3.16728 7.535 2.38805 6.8575 1.85295C6.18437 1.3213 5.22103 1.04238 4.04126 1.04238C2.89834 1.04238 1.93874 1.33669 1.26144 1.87437C0.580793 2.41471 0.196191 3.19282 0.196191 4.13036C0.196191 4.49569 0.500646 4.80015 0.865986 4.80015H1.47618C1.83939 4.80015 2.14598 4.50911 2.14598 4.13036C2.14598 3.90794 2.2062 3.62035 2.45473 3.38644C2.70478 3.1511 3.16985 2.94697 4.02996 2.94697C5.04366 2.94697 5.50918 3.19377 5.72697 3.44013C5.94549 3.6873 5.94784 3.96897 5.94784 4.13036C5.94784 4.54904 5.86578 4.75805 5.74894 4.88454C5.62656 5.01703 5.44335 5.08702 5.16233 5.17308C4.30698 5.42008 3.70727 5.75231 3.32732 6.28485C2.94855 6.81574 2.80647 7.5204 2.80647 8.46951C2.80647 8.83485 3.11092 9.13931 3.47626 9.13931H4.07516C4.4405 9.13931 4.74495 8.83485 4.74495 8.46951C4.74495 8.14617 4.74863 7.91221 4.76839 7.73486C4.78812 7.55784 4.82234 7.4547 4.87123 7.38336C4.91856 7.3143 4.99094 7.25862 5.12273 7.20042C5.25695 7.14115 5.43535 7.08641 5.68514 7.00977L5.68871 7.00867L5.68984 7.00833L5.69162 7.00781C6.01371 6.91175 6.56972 6.74592 7.04342 6.32602C7.52533 5.89883 7.90892 5.22136 7.90893 4.13036Z"
        strokeWidth="0.3"
      />
      <Path
        d="M3.84918 9.4606C3.21378 9.4606 2.71609 9.94472 2.71609 10.5937C2.71609 11.2291 3.20021 11.7268 3.84918 11.7268C4.48458 11.7268 4.98227 11.2427 4.98227 10.5937C4.98227 9.95829 4.49815 9.4606 3.84918 9.4606Z"
        strokeWidth="0.3"
      />
    </Svg>
  );
};
export default QuestionMark;
